import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ArrowRight } from 'lucide-react'
import {
  Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'

export default function Home() {
  const [count, setCount] = useState(0)

  const { data: health, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: async () => {
      const response = await axios.get('/api/v1/health/')
      return response.data
    },
  })

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/80 to-primary flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader>
          <CardTitle className="text-2xl">MooderERP</CardTitle>
          <CardDescription>Enterprise Resource Planning System</CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="rounded-lg border bg-muted/40 p-4">
            <p className="text-sm font-medium text-muted-foreground mb-2">Backend Status</p>
            {isLoading ? (
              <p className="text-sm">Checking…</p>
            ) : error ? (
              <Badge variant="destructive">Backend unavailable</Badge>
            ) : health ? (
              <div className="flex flex-col gap-1">
                <Badge variant="default" className="w-fit bg-green-600 hover:bg-green-600/90">
                  {health.status.toUpperCase()}
                </Badge>
                <p className="text-xs text-muted-foreground">Service: {health.service}</p>
                <p className="text-xs text-muted-foreground">Version: {health.version}</p>
              </div>
            ) : null}
          </div>

          <div className="text-center space-y-2">
            <p className="text-sm text-muted-foreground">Counter: {count}</p>
            <Button onClick={() => setCount((c) => c + 1)} variant="secondary" size="sm">
              Increment
            </Button>
          </div>
        </CardContent>

        <CardFooter className="flex flex-col items-stretch gap-3">
          <div className="flex gap-2">
            <Button asChild variant="default" className="flex-1">
              <Link to="/login">User Login <ArrowRight className="ml-1 h-4 w-4" /></Link>
            </Button>
            <Button asChild variant="outline" className="flex-1">
              <Link to="/admin/login">Admin Login <ArrowRight className="ml-1 h-4 w-4" /></Link>
            </Button>
          </div>
          <p className="text-xs text-center text-muted-foreground">Project TRL 7 : 2026</p>
        </CardFooter>
      </Card>
    </div>
  )
}
